import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../../../../global.service';
import { EventsService } from '../../../events.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-pubg-lite',
  templateUrl: './ramadan20-pubg-lite.component.html',
  styleUrls: ['./ramadan20-pubg-lite.component.css']
})
export class Ramadan20PubgLiteComponent implements OnInit {

  gameName = "pubg-lite";

  constructor(public globalService: GlobalService, public eventService: EventsService, private activeRoute: ActivatedRoute) {
  }

  ngOnInit() {
  }

}
